import React from 'react';
import PropTypes, { arrayOf, shape, func, string } from 'prop-types';
import { connect } from 'react-redux';
import { returnLabelProps } from './proptypes';
import { ReturnOrdersWrapper, Title } from './styles';
import { ReturnCard } from './returnCard';

const mapStateToProps = ({
  language: { 'returns.step_1.item_level_grouping.my_returns.title': title } = {},
}) => ({
  title,
});

const ReturnOrdersComponent = ({
  returnLabels = [],
  printLabel,
  cancelLabel,
  openCancelModal,
  showButtonTrack,
  showButtonReprintLabel,
  showButtonCancel,
  isNotShipped,
  title,
}) => {
  const handlers = {
    printLabel,
    cancelLabel,
    openCancelModal,
  };
  const flags = {
    showButtonTrack,
    showButtonReprintLabel,
    showButtonCancel,
    isNotShipped,
  };

  if (!returnLabels || returnLabels.length === 0) return null;

  return (
    <ReturnOrdersWrapper className="initiated-returns-container">
      <Title className="my-returns-header">{title}</Title>
      {returnLabels.map((label, index) => (
        <ReturnCard {...{ label, handlers, index, flags, key: label.return_id }} />
      ))}
    </ReturnOrdersWrapper>
  );
};

export const ReturnOrders = connect(mapStateToProps)(ReturnOrdersComponent);

ReturnOrdersComponent.propTypes = {
  printLabel: func.isRequired,
  openCancelModal: func.isRequired,
  cancelLabel: func.isRequired,

  returnLabels: arrayOf(shape(returnLabelProps)),
  naItems: arrayOf(PropTypes.any),

  showButtonTrack: func.isRequired,
  showButtonReprintLabel: func.isRequired,
  showButtonCancel: func.isRequired,
  isNotShipped: func.isRequired,
  title: string.isRequired,
};

ReturnOrdersComponent.defaultProps = {
  returnLabels: [],
  naItems: [],
};
